module.exports = __webpack_public_path__ + "static/fabric-image-fit-cover-98a5f0c5a73773129d45614da006fd61.png";